module.exports = "/_next/static/images/web3-acceleration-banner-bb61325c0cdfb3351d104d058f4fd152.webp";